<template>
  <div class="h-full">
    <Swiper :modules="modules" :pagination="true" :slides-per-view="1" class="h-full">
      <SwiperSlide>
        <img class="guide-img mt-6" src="@/assets/guides/dashboard/welcome.webp" />
        <p class="guide-text mt-6">
          The <span class="font-bold">Dashboard</span> serves as your main hub while navigating around the
          <span class="font-bold">NCSS App.</span> Here, you can view key metrics and insights about your portfolio of
          <span class="font-bold">properties at a glance.</span>
        </p>
      </SwiperSlide>
      <SwiperSlide>
        <img class="guide-img mt-6" src="@/assets/guides/dashboard/map-1.webp" />
        <p class="guide-text my-6">
          Links to properties that are <span class="font-bold">visible</span> in the
          <span class="font-bold">map</span> will also appear in the <span class="font-bold">Nearby</span> section.
        </p>
        <img class="guide-img mt-6" src="@/assets/guides/dashboard/map-2.webp" />
      </SwiperSlide>
      <SwiperSlide>
        <img class="guide-img mt-6" src="@/assets/guides/dashboard/recent-properties-1.webp" />
        <p class="guide-text my-6"><span class="font-bold">Insightful</span> property stats at your fingertips!</p>
        <img class="guide-img mt-6" src="@/assets/guides/dashboard/recent-properties-2.webp" />
      </SwiperSlide>
      <SwiperSlide>
        <p class="guide-text my-6">
          Use the <span class="font-bold">Search Bar</span> at the top of the screen to
          <span class="font-bold">immediately find</span> what you're looking for!
        </p>
        <img class="guide-img my-6" src="@/assets/guides/dashboard/search.webp" />
        <p class="guide-text mt-6">
          Looking for a <span class="font-bold">property?</span><br />Search by
          <span class="font-bold">name</span> and/or <span class="font-bold">address!</span>
        </p>
        <p class="guide-text mt-6">
          Looking for a <span class="font-bold">device?</span><br />Search by its
          <span class="font-bold">serial number!</span>
        </p>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup lang="ts">
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';

const modules = [Pagination];
</script>

<style scoped>
.guide-img {
  @apply w-full max-w-[300px] md:max-w-[350px] mx-auto;
}
.guide-text {
  @apply w-[300px] max-w-[75%] mx-auto text-center text-gray-700 font-normal text-sm md:text-base;
}
</style>
